import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarriersForAssignAndDispatch extends Layout {
    sourceCarriersForAssignAndDispatch: DataSource;
    tableCarriersForAssignment: Table;
}
